<template>
  <div class="mrgt md-mrgt+ lg-mrgt++">
    <div class="container container--small">
      <Mobility
        v-if="usageId === 'mobility'"
        :title="gettext('Rappel de votre consommation')"
        light
      />
      <Consumption
        v-else
        :title="gettext('Rappel de votre consommation')"
        :with-power="['heating', 'industrial'].includes(usageId)"
        light
      />
    </div>

    <hr class="mrgv md-mrgv+" />

    <div class="container container--small">
      <template v-if="usageId === 'mobility'">
        <h3>{{ gettext('Carburant GNC') }}</h3>
        <MobilityPriceSummary class="mrgb+" />

        <template v-if="usage?.certificates?.length">
          <h3 class="mrgb--">
            {{ gettext('Optez pour 100% de biogaz suisse') }}
          </h3>
          <p class="text-muted mrgt0">
            {{
              gettext(
                'Roulez grâce à une énergie renouvelable produite localement.'
              )
            }}
          </p>
          <ProductsGrid :products="usage?.certificates" />
        </template>
      </template>

      <template v-else>
        <template v-if="usage?.mainProduct">
          <h2 class="mrgt0 mrgb-">{{ gettext('Gaz naturel-biogaz') }}</h2>
          <Product
            :product="usage?.mainProduct"
            :title="gettext('Estimation de votre facture')"
            class="mrgb+"
          />
        </template>

        <template v-if="usage?.products?.length">
          <h2 class="mrgb--">
            {{ gettext('Optez pour 100% de biogaz suisse') }}
          </h2>
          <p class="text-muted mrgt0">
            {{
              gettext(
                'Vous contribuez au développement des énergies renouvelables et soutenez la production locale.'
              )
            }}
          </p>
          <ProductsGrid :products="usage?.products" />
        </template>

        <div v-if="ENP.simulator.pricesFile" class="mrgt+">
          <a :href="ENP.simulator.pricesFile" target="_blank">
            <Icon id="download" class="icon--100 mrgr--" />
            {{ gettext('Télécharger notre grille tarifaire') }}
          </a>
        </div>
      </template>

      <ul
        class="list-stacked list-stacked--tiny text-left text-small text-muted mrgt+"
      >
        <li id="footnote-1">
          ¹
          <template v-if="usageId === 'mobility'">
            {{ gettext('Les prix affichés sont TTC, i.e. TVA incluse.') }}
          </template>
          <template v-else>
            {{
              gettext(
                'Les prix affichés sont TTC, i.e. taxe CO₂ si applicable et TVA incluse(s).'
              )
            }}
            {{
              gettext(
                'Ces montants ne sont que des estimations, résultant de la simulation, et n’engagent pas la société.'
              )
            }}
          </template>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import { onBeforeMount } from 'vue';
import { useRouter } from 'vue-router';

import Consumption from '@/components/simulation/questions/Consumption.vue';
import Mobility from '@/components/simulation/questions/Mobility.vue';
import ProductsGrid from './ProductsGrid.vue';
import MobilityPriceSummary from '@/components/simulation/products/MobilityPriceSummary.vue';
import { useSimulation } from '@/composables/useSimulation';
import Product from '@/components/simulation/products/Product.vue';

const { usageId, usage, estimationCompleted, resetProduct } = useSimulation();

const router = useRouter();

onBeforeMount(() => {
  if (!estimationCompleted.value) {
    router.push({ name: 'estimation' });
  }
});

resetProduct();
</script>
